import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'
import { Separator as Separator_ } from '@root/shared/ui-kit'

import { LimitOrderItemRoot } from './limit-order-item'

export const LimitOrderItemSkeleton: React.FC = () => (
  <LimitOrderItemRoot $active>
    <Item>
      <Skeleton variant="circular" height={36} width={36} />
      <Left>
        <Skeleton height={8} width={120} />
        <Skeleton height={11} width={80} />
        <Skeleton height={8} width={60} />
      </Left>
      <Right>
        <Skeleton height={8} width={120} />
        <Skeleton height={11} width={80} />
        <Skeleton height={8} width={60} />
      </Right>
      <Actions>
        <Skeleton variant="circular" height={12} width={12} />
        <Separator />
        <Skeleton variant="circular" height={12} width={12} />
      </Actions>
    </Item>
    <Info>
      <Skeleton height={8} width={100} />
      <Skeleton height={8} width={100} />
      <Skeleton height={8} width={40} />
    </Info>
  </LimitOrderItemRoot>
)

const Left = styled.div`
  display: grid;
  gap: 2px;
`
const Right = styled.div`
  display: grid;
  gap: 2px;

  justify-items: end;
`

const Item = styled.div`
  height: 60px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  overflow: hidden;
  position: relative;

  border-bottom: 1px solid var(--backgroundA-2);
  padding-inline: 10px 0;
  gap: 8px;
`

const Actions = styled.div`
  border-inline-start: 1px solid var(--backgroundA-2);

  display: grid;
  grid-template-rows: 1fr auto 1fr;

  align-items: center;
  height: 100%;
  width: 30px;
  justify-items: center;
`

const Separator = styled(Separator_)`
  background: var(--backgroundA-2);
  width: 100%;
`

const Info = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  padding-inline: 10px;

  align-items: center;
  justify-content: space-between;
  height: 26px;
`
